export default __webpack_public_path__ + "static/media/accor-plus-digital-vouchers-faqs.fab0fd1d.pdf";